module.exports = __webpack_public_path__ + "media/new/checkmark-blue-9612e8e7.svg";